<template>
  <div class="p-4 border border-2">

    <modal name="add-event" :width="500" :height="600" :adaptive="true">
      <div class="modal-dialog  p-4">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title bold">Nuovo evento</h5>
            <button type="button" class="close mt-2" @click="hideModal">
              <span>&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form>
              <div class="form-group">
                <label for="event-title">Titolo evento</label>
                <input type="text"
                       :class=" errorForm && errorForm.title ? 'form-control border-2 border-danger' :  'form-control'"
                       v-model="eventTitle" placeholder="Inserisci il titolo dell'evento" required>
              </div>
              <div class="form-group">
                <label for="event-description">Descrizione evento</label>
                <input type="text"
                       :class=" errorForm && errorForm.description ? 'form-control border-2 border-danger' :  'form-control'"
                       v-model="eventDescription" placeholder="Inserisci la descrizione dell'evento" required>
              </div>
              <div class="form-group">
                <label for="event-date">Giorno dell'evento</label>
                <input type="date"
                       :class=" errorForm && errorForm.startDate ? 'form-control border-2 border-danger' :  'form-control'"
                       id="event-date" v-model="startDate" required>
              </div>
              <div class="form-group">
                <label for="event-date">Ora dell'evento</label>
                <input type="time"
                       :class=" errorForm && errorForm.startHour ? 'form-control border-2 border-danger' :  'form-control'"
                       id="event-date" v-model="startHour" required>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="hideModal">Annulla</button>
            <button type="button" class="btn btn-primary" @click="saveEvent()">Salva</button>
          </div>
        </div>
      </div>
    </modal>


    <div>
      <div class="row">
        <div class="col-6">
          <p>
            <img src="/img/calendar/logo.png" style="height: 35px"/>
          </p>
        </div>


        <div class="col-6">
          <p class="text-right">
            <a href="/google/auth"
               v-if="!user.google_token"
               class="p-2 abtg__btn-third btn shadow-none">
              Attiva il calendario Google
            </a>

            <button
                v-if="user && user.google_token"
                @click="getCalendarEvents()" class="p-2 btn abtg__btn-default shadow-none">
              Sincronizza
            </button>
            <button v-if="user && user.google_token" class="p-2 abtg__btn-third btn shadow-none" @click="showModal">
              Nuovo evento
            </button>
          </p>
        </div>
      </div>
      <table class="table table-striped">
        <thead>

        <tr>

          <th>Descrizione Evento</th>
          <th>Inizio</th>
          <th>Fine</th>
        </tr>
        </thead>

        <tbody>
        <tr v-for="evento in events">

          <td>
            <p class="font-bold">{{ evento.title }}</p>
            <p v-html="evento.description"></p></td>
          <td nowrap>{{ formatDate(evento.start) }}</td>
          <td nowrap>{{ formatDate(evento.end) }}</td>
        </tr>
        <tr v-if="events.length === 0">
          <td colspan="4" class="text-center"><h4 class="bold">Nessun evento da visualizzare</h4></td>
        </tr>
        </tbody>
      </table>

    </div>
    <p>
      <button
          v-if="user && user.google_token"
          @click="removeCalendarAuth()" class="p-2 btn abtg__btn-default shadow-none float-right"
          style="background-color: red!important;color:white !important;font-size:70% !important;">
        Disattiva calendar
      </button>
    </p>
  </div>
</template>

<script>
import {mapActions, mapState, mapMutations} from 'vuex'

export default {
  components: {},
  data() {
    return {
      user: null,
      events: null,
      eventTitle: null,
      eventDescription: null,
      startDate: null,
      startHour: null,
      errorForm: null
    }
  },
  computed: {
    ...mapState('n_calendar', ['checkIfIsAuthorized', 'formData', 'calendarList', 'eventList']),

  },
  mounted() {
    this.getUser();
    this.getEvents();
  },

  created() {
  },

  methods: {
    ...mapActions('n_calendar', ['removeAuthorization', 'eventSource', 'findEvent']),
    ...mapMutations('n_calendar', ['SET_DATA']),

    getUser() {
      axios.get('/api/v1/user')
          .then(response => {
            this.user = response.data
          })
    },


    getEvents() {
      axios.get('/api/v1/google-calendar/stored-events')
          .then(response => {
            this.events = response.data
          })
    },


    getCalendarEvents() {
      axios.get('/api/v1/google-calendar/events')
          .then(response => {
            this.events = response.data
          })
    },


    formatDate(isoString) {
      const date = new Date(isoString);
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const day = date.getDate();
      const hours = date.getHours();
      let minutes = date.getMinutes();

      if (minutes === 0) {
        minutes = minutes + '0';
      }
      return `${day}/${month}/${year} ${hours}:${minutes}`;
    },

    showModal() {
      this.$modal.show('add-event')
    },

    hideModal() {
      this.$modal.hide('add-event')
    },

    saveEvent() {
      axios.post('/api/v1/google-calendar/save-events', {
        title: this.eventTitle,
        description: this.eventDescription,
        startDate: this.startDate,
        startHour: this.startHour
      }).then(() => {
        this.hideModal();
        this.getCalendarEvents();
        window.location.reload()
      })
          .catch(error => {
            this.errorForm = error.response.data.errors
          })
    },
    removeCalendarAuth() {
      axios.get('/api/v1/google-calendar/remove-auth')
          .then(() => {
            window.location.reload()
          })
    },

  },
}
</script>
